import en from './en.json';
import fi from './fi.json';
import sv from './sv.json';
export default {
  en,
  sv,
  fi,
} as const;
